<template>
  <header class="apple-header-wrapper">
    <!-- Apple Global Navigation -->
    <nav class="global-nav" aria-label="Global Navigation">
      <div class="nav-content">
        <router-link to="/" class="nav-logo" aria-label="Apple">
          <img src="@/assets/logo-white.png" alt="Apple Logo" class="apple-logo-img" />
        </router-link>

        <ul class="nav-links">
          <li><router-link to="/">{{ t.nav.store }}</router-link></li>
          <li><a href="/#section-mac" @click.prevent="navigateSection('mac')">{{ t.nav.mac }}</a></li>
          <li><a href="/#section-ipad" @click.prevent="navigateSection('ipad')">{{ t.nav.ipad }}</a></li>
          <li><a href="/#section-iphone" @click.prevent="navigateSection('iphone')">{{ t.nav.iphone }}</a></li>
          <li><a href="/#section-vision" @click.prevent="navigateSection('vision')">{{ t.nav.vision }}</a></li>
          <li><a href="/#section-vision" @click.prevent="navigateSection('vision')">{{ t.nav.airpods }}</a></li>
          <li><router-link to="/form" class="nav-highlight-link">{{ locale === 'es-EC' ? 'Canjear' : 'Redeem' }}</router-link></li>
        </ul>

        <div class="nav-right">
          <router-link to="/form" class="nav-user-btn" aria-label="Account Login">
            <svg class="apple-user-icon" viewBox="0 0 16 16" width="16" height="16" fill="currentColor">
              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1.2c-2.4 0-7.2 1.2-7.2 3.6V14h14.4v-1.2c0-2.4-4.8-3.6-7.2-3.6z"/>
            </svg>
          </router-link>
        </div>
      </div>
    </nav>

    <!-- Sticky iOS 18 Sub-Navigation Ribbon -->
    <nav class="sub-nav" v-if="showSubNav" aria-label="iOS 18 Navigation">
      <div class="sub-nav-content">
        <div class="sub-nav-title">
          <router-link to="/" class="product-title">
            <span class="product-main">iOS 18</span>
            <span class="product-badge">iPhone 18</span>
          </router-link>
        </div>

        <div class="sub-nav-links">
          <a href="/#overview" class="sub-link">{{ t.nav.overview }}</a>
          <a href="/#intelligence" class="sub-link highlight">{{ t.nav.intelligence }}</a>
          <a href="/#customization" class="sub-link">{{ t.nav.personalize }}</a>
          <a href="/#photos" class="sub-link">{{ t.nav.photos }}</a>
          <a href="/#messages" class="sub-link">{{ t.nav.messages }}</a>
          <a href="/#compatibility" class="sub-link">{{ t.nav.compatibility }}</a>
          <router-link to="/form" class="cta-pill">{{ t.nav.preOrder }}</router-link>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { useI18n } from '@/i18n';

export default {
  name: 'AppleNav',
  props: {
    showSubNav: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDropdown: false
    };
  },
  setup() {
    const { t, locale, setLocale } = useI18n();
    return {
      t,
      locale,
      setLocale
    };
  },
  computed: {
    currentRegionLabel() {
      return this.locale === 'es-EC' ? 'Ecuador' : 'United States';
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    toggleDropdown(e) {
      e.stopPropagation();
      this.showDropdown = !this.showDropdown;
    },
    changeLocale(newLocale) {
      this.setLocale(newLocale);
      this.showDropdown = false;
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false;
      }
    },
    navigateSection(id) {
      if (this.$route.path === '/' || this.$route.path === '/store') {
        const el = document.getElementById('section-' + id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        this.$router.push({ path: '/' }).then(() => {
          this.$nextTick(() => {
            const el = document.getElementById('section-' + id);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        });
      }
    }
  }
}
</script>

<style scoped>
.apple-header-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

/* Global Nav */
.global-nav {
  height: 44px;
  background: rgba(22, 22, 23, 0.92);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
}

.nav-content {
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 22px;
  position: relative;
}

.nav-logo {
  display: flex;
  align-items: center;
  color: #f5f5f7;
  opacity: 0.92;
  transition: opacity 0.2s;
  z-index: 2;
  flex: 0 0 auto;
}

.nav-logo:hover {
  opacity: 1;
}

.apple-logo-img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  margin-left: 48px;
  margin-right: auto;
  padding: 0;
  gap: 50px;
  align-items: center;
}

.nav-links a {
  color: #d6d6d8;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.01em;
  opacity: 0.8;
  transition: opacity 0.2s;
  white-space: nowrap;
}

.nav-links a:hover {
  color: #ffffff;
  opacity: 1;
}

.nav-links .nav-highlight-link {
  color: #2997ff;
  opacity: 1;
  font-weight: 400px;
}

.nav-links .nav-highlight-link:hover {
  color: #70baff;
}

.nav-right {
  display: flex;
  align-items: center;
  z-index: 2;
  flex: 0 0 auto;
  margin-left: auto;
}

.nav-user-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: #d6d6d8;
  opacity: 0.85;
  transition: all 0.2s ease;
  cursor: pointer;
  background: transparent;
}

.nav-user-btn:hover {
  opacity: 1;
  color: #ffffff;
  transform: scale(1.08);
}

.apple-user-icon {
  width: 15px;
  height: 15px;
  display: block;
}

.locale-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #e5e5ea;
  padding: 4px 9px;
  border-radius: 980px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s;
}

.locale-btn:hover {
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.flag-icon {
  font-size: 12px;
  line-height: 1;
}

.country-tag {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: -0.01em;
}

.dropdown-chevron {
  opacity: 0.7;
}

.locale-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: rgba(28, 28, 30, 0.96);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 6px;
  min-width: 170px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
  z-index: 1010;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.locale-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  width: 100%;
  border: none;
  background: transparent;
  color: #f5f5f7;
  font-size: 12px;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;
}

.locale-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.locale-item.active {
  background: rgba(0, 113, 227, 0.2);
  color: #2997ff;
  font-weight: 500;
}

.check-mark {
  margin-left: auto;
  font-size: 12px;
}

.nav-reserve-link {
  font-size: 11px;
  background: #0071e3;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 980px;
  transition: background 0.2s;
  font-weight: 500;
}

.nav-reserve-link:hover {
  background: #0077ed;
}

/* Sub-Nav Ribbon */
.sub-nav {
  height: 52px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: background 0.3s;
}

.sub-nav-content {
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 22px;
}

.sub-nav-title {
  display: flex;
  align-items: center;
}

.product-title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  color: #1d1d1f;
}

.product-main {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.product-badge {
  font-size: 11px;
  font-weight: 500;
  color: #0071e3;
  background: rgba(0, 113, 227, 0.1);
  padding: 2px 7px;
  border-radius: 6px;
}

.sub-nav-links {
  display: flex;
  align-items: center;
  gap: 20px;
}

.sub-link {
  color: #424245;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.01em;
  transition: color 0.2s;
}

.sub-link:hover {
  color: #0071e3;
}

.sub-link.highlight {
  background: linear-gradient(90deg, #ff3b30, #ff9500, #007aff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 600;
}

.cta-pill {
  font-size: 12px;
  font-weight: 400;
  padding: 4px 14px;
  border-radius: 980px;
  background: #0071e3;
  color: #ffffff;
  transition: background 0.2s, transform 0.15s;
}

.cta-pill:hover {
  background: #0077ed;
  opacity: 1;
  transform: scale(1.02);
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }

  .sub-nav-links .sub-link:not(.highlight) {
    display: none;
  }
}
</style>
